import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SelectedCompanyState {
  selectedCompany: number | null;
}

const initialState: SelectedCompanyState = {
  selectedCompany: null,
};

const selectedCompanySlice = createSlice({
  name: 'selectedCompany',
  initialState,
  reducers: {
    setSelectedCompany(state, action: PayloadAction<number | null>) {
      state.selectedCompany = action.payload;
    },
  },
});

export const { setSelectedCompany } = selectedCompanySlice.actions;
export default selectedCompanySlice.reducer;